import { Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Card,
  CardHeader,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import { App } from "antd";
import { useFormik } from "formik";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import MDBox from "~/components/MDBox";
import MDButton from "~/components/MDButton";
import DashboardLayout from "~/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "~/examples/Navbars/DashboardNavbar";
import { useChangePasswordMutation } from "~/queries/authQueries";

const ChangePassword = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const { message } = App.useApp();
  const navigate = useNavigate();
  // query mutation hooks
  const formRef = useRef(null);
  const changePassword = useChangePasswordMutation();

  const formik = useFormik({
    initialValues: {
      currentPassword: "",
      newPassword: "",
      submit: null,
    },
    validationSchema: Yup.object({
      currentPassword: Yup.string().required("Current Password is required"),
      newPassword: Yup.string()
        .notOneOf(
          [Yup.ref("currentPassword"), null],
          "New Password must be different from Current Password"
        )
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{1,}$/,
          "Password must contain at least one special character, one number, one uppercase letter, and one lowercase letter"
        )
        .max(16, "New Password must be at most 16 characters")
        .required("New Password is required"),
    }),
    onSubmit: async (values, helpers) => {
      try {
        const { currentPassword, newPassword } = values;
        const response = await changePassword.mutateAsync({
          currentPassword,
          newPassword,
        });

        message.success("Password Changed Successfully!");
        helpers.resetForm();
        sessionStorage.setItem("passwordType", 0);
        navigate("/dashboard");
        // navigate(config.defaultPath, { replace: true });
      } catch (err) {
        message.error(err.response?.data?.message);
        console.log("<< Error >>", err);
        helpers.setStatus({ success: false });
        helpers.setSubmitting(false);
      }
    },
  });

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleClickShowNewPassword = () => {
    setShowNewPassword(!showNewPassword);
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleMouseDownNewPassword = (event) => {
    event.preventDefault();
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <Card>
        <MDBox p={2}>
          <CardHeader title="Change Password" />
        </MDBox>
        <MDBox p={2}>
          <form noValidate onSubmit={formik.handleSubmit}>
            <Grid container spacing={2}>
              <Grid item lg={6}>
                <FormControl
                  margin="normal"
                  required
                  fullWidth
                  error={
                    formik.touched.currentPassword &&
                    Boolean(formik.errors.currentPassword)
                  }
                >
                  <InputLabel htmlFor="currentPassword">
                    Current Password
                  </InputLabel>
                  <OutlinedInput
                    id="currentPassword"
                    name="currentPassword"
                    label="Current Password"
                    type={showPassword ? "text" : "password"}
                    autoComplete="Current password"
                    {...formik.getFieldProps("currentPassword")}
                    error={
                      formik.touched.currentPassword &&
                      Boolean(formik.errors.currentPassword)
                    }
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                  {formik.touched.currentPassword &&
                    formik.errors.currentPassword && (
                      <FormHelperText error>
                        {formik.errors.currentPassword}
                      </FormHelperText>
                    )}
                </FormControl>
              </Grid>
              <Grid item lg={6}>
                <FormControl
                  margin="normal"
                  required
                  fullWidth
                  error={
                    formik.touched.newPassword &&
                    Boolean(formik.errors.newPassword)
                  }
                >
                  <InputLabel htmlFor="newPassword">New Password</InputLabel>
                  <OutlinedInput
                    id="newPassword"
                    name="newPassword"
                    label="New Password"
                    type={showNewPassword ? "text" : "password"}
                    autoComplete="New-password"
                    {...formik.getFieldProps("newPassword")}
                    error={
                      formik.touched.newPassword &&
                      Boolean(formik.errors.newPassword)
                    }
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowNewPassword}
                          onMouseDown={handleMouseDownNewPassword}
                        >
                          {showNewPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                  {formik.touched.newPassword && formik.errors.newPassword && (
                    <FormHelperText error>
                      {formik.errors.newPassword}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid
                container
                my={2}
                spacing={2}
                justifyContent="end"
                alignItems="center"
              >
                <Grid item lg={2}>
                  <MDButton
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="success"
                    size="large"
                    onClick={() => console.log("ON SUBMIT", formRef.current)}
                  >
                    Submit
                  </MDButton>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </MDBox>
      </Card>
    </DashboardLayout>
  );
};

export default ChangePassword;
